import React, { useState } from "react";
import { Icon } from "@iconify/react";
import NotificationModal from "../../modals/notificationModal";
import { useNavigate } from "react-router-dom";

const AdminDashnavbar = ({ toggleDrawer }) => {
  const navigate = useNavigate();
  const [isnotifyModelOpen, setisnotifyModelOpen] = useState(false);
  const openNotificationModal = () => {
    setisnotifyModelOpen(true);
  };

  return (
    <>
      <div className="dashnavbar-container h-fit flex items-center justify-between w-[calc(100vw-310px)] max-md:w-full">
        <div className="dashnav-left">
          <Icon
            icon="ion:menu"
            width={20}
            height={20}
            onClick={toggleDrawer}
            className="hidden max-md:flex cursor-pointer"
          />
        </div>

        <div className="dashnav-right w-100 flex justify-end gap-[15px] sm-s:gap-[8px]">
          {/* Notifications */}
          <div className="relative flex justify-center items-center w-[45px] h-[45px] sm-s:h-[40px] sm-s:w-[40px] txt-color rounded-[28.5px] p-[8px] border-[1.299px] border-white bg-[rgba(255,255,255,0.30)] shadow-[0px_11px_23.2px_#E1E2EF] backdrop-blur-[72.719px]">
            <Icon
              icon="material-symbols-light:notifications-outline-sharp"
              width={28}
              height={28}
              onClick={openNotificationModal}
              className="cursor-pointer relative sm-s:h-[22px] sm-s:w-[22px]"
            />
            <div
              onClick={openNotificationModal}
              className="cursor-pointer w-[8px] h-[8px] bg-[#00BBDD] rounded-[50px] absolute top-[25%] right-[30%]"
            ></div>
          </div>
          {/* Settings */}
          <div
            className="w-[45px] h-[45px] sm-s:h-[40px] sm-s:w-[40px] cursor-pointer rounded-[31px] flex items-center justify-center py-[3px] px-[16px] bg-[var(--Primary-color,#143A62)] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)] backdrop-blur-[72.719px]"
            onClick={() => navigate("/admin-settings")}
          >
            <h6 className="uppercase text-white font-semibold">t</h6>
          </div>
        </div>
      </div>

      <NotificationModal
        isnotifyModelOpen={isnotifyModelOpen}
        setisnotifyModelOpen={setisnotifyModelOpen}
      />
    </>
  );
};

export default AdminDashnavbar;
